import {
  GET_COOPERATION_REQ,
  REMOVE_COOPERATION_REQ,
  GET_COOPERATION_REQ_BY_ID,
} from "../actions/cooperation-requset-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const cooperationReqReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (GET_COOPERATION_REQ.REQUEST,
    GET_COOPERATION_REQ_BY_ID.REQUEST,
    REMOVE_COOPERATION_REQ.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (GET_COOPERATION_REQ.SUCCESS,
    GET_COOPERATION_REQ_BY_ID.SUCCESS,
    REMOVE_COOPERATION_REQ.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (GET_COOPERATION_REQ.FAILURE,
    GET_COOPERATION_REQ_BY_ID.FAILURE,
    REMOVE_COOPERATION_REQ.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { cooperationReqReducer };
